import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const activityLogSlice = createAppSlice({
  name: 'activityLog',
  initialState,
  reducers,
});

export const {
  fetchMostRecentActivity,
  fetchActivityLog,
  setShowActivityLogModal,
  setMoreActivitiesAvailable,
  clearActivityLog,
} = activityLogSlice.actions;

export default activityLogSlice.reducer;
